/* The Rugs :: Guide article template behaviour. Per-article automatic, no editing per post. */
(function () {
  var root = document.querySelector('[data-ag-root]');
  if (!root) return;

  var handle = root.getAttribute('data-ag-handle') || location.pathname;
  var body = root.querySelector('[data-ag-body]');

  if (body) {
    Array.prototype.forEach.call(body.querySelectorAll('h1,h2,h3,h4,h5,h6'), function (h) {
      var t = (h.textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length) return;
      var p = document.createElement('p');
      while (h.firstChild) p.appendChild(h.firstChild);
      h.parentNode.replaceChild(p, h);
    });
  }

  var toc = root.querySelector('[data-ag-toc]');
  var nav = toc && toc.querySelector('[data-ag-toc-nav]');
  var left = toc && toc.querySelector('[data-ag-toc-left]');
  var heads = [];

  if (body && nav) {
    var nodes = body.querySelectorAll('h2');
    var idx = 0;
    Array.prototype.forEach.call(nodes, function (h) {
      var label = (h.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label) return;
      if (h.closest('.ag-slot,.ag-faq,.ag-finder,.ag-poll,.ag-cpicks,.ag-mt,.ag-picks')) return;
      idx++;
      if (!h.id) h.id = 'ag-s' + idx;
      heads.push(h);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ag-toc__item';
      var n = document.createElement('span');
      n.textContent = (idx < 10 ? '0' : '') + idx;
      var t = document.createElement('span');
      t.textContent = label;
      b.appendChild(n);
      b.appendChild(t);
      b.addEventListener('click', function () {
        var y = h.getBoundingClientRect().top + window.pageYOffset - 110;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
      nav.appendChild(b);
    });
    if (!heads.length && toc) toc.style.display = 'none';
  }

  var tocToggle = toc && toc.querySelector('[data-ag-toc-toggle]');
  if (tocToggle) {
    tocToggle.addEventListener('click', function () {
      var open = toc.getAttribute('data-open') !== 'false';
      toc.setAttribute('data-open', open ? 'false' : 'true');
      tocToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      tocToggle.textContent = open ? '+' : '\u2212';
    });
  }

  var bar = root.querySelector('[data-ag-progress]');
  var dock = root.querySelector('[data-ag-dock]');
  var totalMins = parseInt(root.getAttribute('data-ag-mins') || '0', 10);
  var items = nav ? nav.querySelectorAll('.ag-toc__item') : [];
  var raf = null;

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      if (!body) return;
      var r = body.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (-r.top + 120) / Math.max(1, r.height - window.innerHeight * 0.6)));
      if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      if (left && totalMins) left.textContent = Math.max(1, Math.round(totalMins * (1 - p))) + ' min left';
      if (dock) dock.setAttribute('data-show', p > 0.06 && p < 0.96 ? 'true' : 'false');
      var active = 0;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].getBoundingClientRect().top < 160) active = i;
      }
      for (var j = 0; j < items.length; j++) {
        items[j].setAttribute('aria-current', j === active ? 'true' : 'false');
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var KEY = 'therugs:saved-guides';
  var saveBtn = root.querySelector('[data-ag-save]');
  function readSaved() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  if (saveBtn) {
    var paint = function (on) {
      saveBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      saveBtn.textContent = on ? '\u2665 Saved' : '\u2661 Save';
    };
    paint(readSaved().indexOf(handle) > -1);
    saveBtn.addEventListener('click', function () {
      var list = readSaved();
      var at = list.indexOf(handle);
      if (at > -1) list.splice(at, 1); else list.push(handle);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      paint(at === -1);
    });
  }

  var shareBtn = root.querySelector('[data-ag-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = location.href.split('#')[0];
      var done = function () {
        shareBtn.textContent = '\u2713 Link copied';
        setTimeout(function () { shareBtn.textContent = '\u2197 Share'; }, 1800);
      };
      if (navigator.share && window.matchMedia('(max-width:900px)').matches) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
    });
  }

  var poll = root.querySelector('[data-ag-poll]');
  if (poll) {
    var opts = poll.querySelectorAll('[data-ag-poll-opt]');
    var seed = [];
    Array.prototype.forEach.call(opts, function (o) { seed.push(parseInt(o.getAttribute('data-seed') || '10', 10)); });

    var paintPoll = function (pickedIndex) {
      var counts = seed.slice();
      if (pickedIndex != null) counts[pickedIndex] += 1;
      var total = counts.reduce(function (a, b) { return a + b; }, 0) || 1;
      Array.prototype.forEach.call(opts, function (o, i) {
        var pct = Math.round((counts[i] / total) * 100);
        o.querySelector('.ag-poll__fill').style.width = pickedIndex == null ? '0%' : pct + '%';
        o.querySelector('.ag-poll__pct').textContent = pct + '%';
        o.setAttribute('data-picked', i === pickedIndex ? 'true' : 'false');
        o.setAttribute('aria-pressed', i === pickedIndex ? 'true' : 'false');
      });
      poll.setAttribute('data-voted', pickedIndex == null ? 'false' : 'true');
      var note = poll.querySelector('[data-ag-poll-note]');
      if (note) note.textContent = pickedIndex == null
        ? 'Tap an option to see how other readers answered.'
        : (opts[pickedIndex].getAttribute('data-followup') || 'Thanks for voting.');
    };

    paintPoll(null);

    Array.prototype.forEach.call(opts, function (o, i) {
      o.addEventListener('click', function () {
        paintPoll(i);
        var target = o.getAttribute('data-goto');
        var cta = poll.querySelector('[data-ag-poll-cta]');
        if (target && cta) { cta.href = target; cta.hidden = false; }
      });
    });
  }
})();

/* Optional add-on: Save -> email capture. Delete assets/article-save-capture.js to switch it off. */
(function () {
  try {
    var cs = document.currentScript;
    var src = cs && cs.src;
    if (!src || src.indexOf('article-guide.js') === -1) return;
    var s = document.createElement('script');
    s.src = src.replace('article-guide.js', 'article-save-capture.js');
    s.defer = true;
    document.head.appendChild(s);
  } catch (e) {}
})();
